// extracted by mini-css-extract-plugin
export default {"container":"UserPageTabsSkeleton_container__tMoVR","tab":"UserPageTabsSkeleton_tab__uFKaj","text":"UserPageTabsSkeleton_text__9yoSb"};